<quill-editor #editor [placeholder]="placeHolder" class="quill-editor" (onEditorCreated)="setFocus($event)"
  [class.required]="control.invalid && showError" [formControl]="control" [atMentionConfig]="atMentionConfig"
  (onContentChanged)="onEditorContentChanged($event)"></quill-editor>
<div class="sendData">
  <div class="warning-msg">
    * To save and send comments, please click SAVE.
  </div>
  <div>
    <span><button (click)="send()" class="edit-post-save">Save</button></span>
    <!-- <span *ngIf="!openEditForm" (click)="send()" class="cursor-pointer">
      <img [src]="'images/send.svg' | assetUrl" alt="send icon"
    /></span> -->
  </div>
</div>